export default {
  type: 'layoutRows',
  shadow: '@theme:card.shadow',
  fontName: '@theme:card.fontName',
  roundedBottom: '@theme:card.rounded',
  bgColor: 'white',
  borderColor: 'primary',
  borderLeft: true,
  borderBottom: true,
  borderRight: true,
  padding: '0',
  fontSize: '3',
  style: { lineHeight: '1' },
  separatorJourneyTypeProps: {
    content: '|',
  },
  showJourneyType: true,
  showTravelClass: true,
  fareItemOriginDestination: {
    showOriginAirportCode: true,
    showDestinationAirportCode: true,
    showOriginLabel: true,
    showDestinationLabel: true,
    showSeparator: false,
    showLineSeparator: true,
    fontSize: '3',
    textTransform: 'capitalize',
    marginBottom: '2',
    style: {
      lineHeight: '1',
    },
    originLabelStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    destinationLabelStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    originAirportCodeStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    destinationAirportCodeStyles: {
      paddingRight: '1',
      fontWeight: 'bold',
    },
    lineSeparatorStyles: {
      marginBottom: '1',
    },
  },
  showRoute: false,
  fareItemRoute: {
    fontWeight: 'bold',
    fontSize: '4',
    paddingBottom: '1',
    separatorLabel: {
      content: 'minus',
    },
  },
  showDepartureInfo: true,
  fareItemDepartureInfo: {
    showDepartureText: false,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: true,
  fareItemReturnInfo: {
    showReturnText: false,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  showOriginDestinationImage: true,
  fareItemOriginDestinationImage: {
    heightDestinationImage: 100,
    widthDestinationImage: 100,
    roundedCircle: true,
  },
  showPrice: true,
  fareItemDepartureReturn: {
    marginBottom: '1',
  },
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    fontSize: '4',
    textAlign: 'right',
    fontWeight: 'bold',
    marginLeft: '1',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    pricePromoStyles: {
      fontWeight: 'normal',
      fontSize: '3',
      textTransform: 'lowercase',
      marginRight: '2',
      textColor: 'dark',
    },
    currencyStyles: {
      marginHeight: '1',
    },
  },
  fareImageContainer: {
    margin: 'auto',
  },
  fareImageItem: {
    grow: '2',
    paddingHeight: '3',
    paddingLeft: '2',
  },
  fareContentItem: {
    grow: '5',
    padding: '2',
    justifyContent: 'between',
  },
  fareFooterItem: {
    alignItems: 'end',
  },
  showDurationTrip: false,
  showLastSeen: true,
  fareItemLastSeen: {
    shadow: '@theme:card.shadow',
    rounded: '@theme:badge.rounded',
    fontName: '@theme:card.fontName',
    bgColor: 'light',
    style: {
      fontSize: '11px',
      paddingLeft: '4px',
      paddingRight: '4px',
      paddingTop: '6px',
      paddingBottom: '6px',
    },
    marginLeft: 'auto',
    marginBottom: '1px',
    labelStyles: {
      fontWeight: 'bold',
    },
  },
  showAirline: false,
  fareItemAirline: {
    showAirlineLogo: true,
    showAirlineName: true,
    borderTop: true,
    airlineNameStyles: {
      fontSize: '3',
    },
  },
  showFareDisclaimer: false,
  fareItemDisclaimer: {
    borderTop: true,
    fontSize: '3',
    paddingWidth: '2',
  },
  showCallToAction: false,
  fareItemCallToAction: {
    showCallToActionTextMin: true,
    shadow: '@theme:button.shadow',
    rounded: '@theme:button.rounded',
    width: '100',
    paddingHeight: '2',
    textTransform: 'uppercase',
    fontSize: '4',
    fontWeight: 'bold',
  },
};
